module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parallax-comp-container"
  }, [_c('div', {
    staticClass: "parallax-comp transparent position-relative",
    style: ({
      width: _vm.imageWidth + 'px',
      height: _vm.imageHeight + 'px',
      background: _vm.backgroundColor
    })
  }, [(_vm.insertMode === 1) ? _c('div', {
    staticClass: "imageBck",
    style: ({
      backgroundImage: _vm.transparent
    })
  }) : _vm._e(), _vm._v(" "), (_vm.insertMode === 2) ? _c('div', {
    staticClass: "imageBck",
    style: ({
      background: 'black'
    })
  }) : _vm._e()]), _vm._v(" "), (_vm.insertMode === 1 && _vm.background1) ? _c('div', {
    staticClass: "parallax-comp background-1 position-absolute",
    style: ({
      width: _vm.imageWidth + 'px',
      height: _vm.imageHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "imageBck",
    style: ({
      backgroundImage: _vm.background1,
      backgroundPositionX: _vm.background1Offset + 'px'
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.insertMode === 1 && _vm.background2) ? _c('div', {
    staticClass: "parallax-comp background-2 position-absolute",
    style: ({
      width: _vm.imageWidth + 'px',
      height: _vm.imageHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "imageBck",
    style: ({
      backgroundImage: _vm.background2,
      backgroundPositionX: _vm.background2Offset + 'px'
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.insertMode === 1 && _vm.foreground1) ? _c('div', {
    staticClass: "parallax-comp foreground-1 position-absolute",
    style: ({
      width: _vm.imageWidth + 'px',
      height: _vm.imageHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "imageBck",
    style: ({
      backgroundImage: _vm.foreground1
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.insertMode === 1 && _vm.foreground2) ? _c('div', {
    staticClass: "parallax-comp foreground-2 position-absolute",
    style: ({
      width: _vm.imageWidth + 'px',
      height: _vm.imageHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "imageBck",
    style: ({
      backgroundImage: _vm.foreground2,
      backgroundPositionX: _vm.foreground2Offset + 'px'
    })
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "parallax-textbox",
    class: _vm.textboxClass,
    style: ({
      background: _vm.textboxColor,
      transform: _vm.textboxZoom,
      top: _vm.textboxPosition ? _vm.textboxPosition.top + 'px' : 0,
      bottom: _vm.textboxPosition ? _vm.textboxPosition.bottom + 'px' : 0,
      left: _vm.textboxPosition ? _vm.textboxPosition.left + 'px' : 0
    })
  }, [_c('div', {
    staticClass: "parallax-text",
    class: _vm.textClass,
    style: ({
      color: _vm.textColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.textboxText)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-612e1e2d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Util/ParallaxComposite.vue
// module id = 327
// module chunks = 1